import reviewWidget from "./components/reviewWidget.vue";
import reviewWidgetAllNew from "./components/reviewWidgetAllNew.vue";
import reviewWidgetAll from "./components/reviewWidgetAll.vue";
import reviewWidgetBadge from "./components/reviewWidgetBadge.vue";
import reviewWidgetStats from "./components/reviewWidgetStats.vue";
import reviewWidgetSummary from "./components/reviewWidgetSummary.vue";

export function createApp() {
    Vue.component( "review-widget", reviewWidget );
    Vue.component( "review-widget-all-new", reviewWidgetAllNew );
    Vue.component( "review-widget-all", reviewWidgetAll );
    Vue.component( "review-widget-badge", reviewWidgetBadge );
    Vue.component( "review-widget-stats", reviewWidgetStats );
    Vue.component( "review-widget-summary", reviewWidgetSummary );
}
